const testimonials = [
    {
        id: 1,
        active: true,
        name: 'Diana',
        system: 'Enhanced system',
        location: 'Chicago, IL',
        text:
            'truesecurity gave us the knowledge and ability to design our own security system.',
        image: '/img/testimonial1.png'
    },
    {
        id: 2,
        active: false,
        name: 'Tamara and Jason',
        system: 'Total system',
        location: 'Chicago, IL',
        text:
            'It was so easy and relaxed, Definitely recommend this to anyone looking for a security system.',
        image: '/img/testimonial2.png'
    },
    {
        id: 3,
        active: false,
        name: 'Samantha and Michael',
        system: 'Enhanced system',
        location: 'Chicago, IL',
        text:
            'Best way to buy home security. period.',
        image: '/img/testimonial3.png'
    },
]

export default testimonials
